import { ACTIONS, QUOTE_STEPS, EVENTS } from "../AppConstants";
import { IVehicle, IDriver, ICurrentInsurance, IContactInfo, IPaymentChoice, IRealTimeAutoResult, ICoverageConfig, IRate, IAgenciesContactInfo } from "../classes/Domain";
import QuoteApiClient from "../classes/QuoteApiClient";
import VehiclesApiClient from "../classes/VehiclesApiClient";
import DriversApiClient from "../classes/DriversApiClient";
import InsuranceApiClient from "../classes/InsuranceApiClient";
import { validationUtils, appValidator } from "../validation/Validation";
import { allFieldsValidation as startQuoteValidation } from "../validation/quickQuote/StartQuoteValidation";
import { allFieldsValidation as vehicleDetailsValidation } from "../validation/quickQuote/VehicleDetailsValidation";
import { allFieldsValidation as howYouDriveValidation } from "../validation/quickQuote/HowYouDriveValidation";
import { allFieldsValidation as aboutYouValidation } from "../validation/quickQuote/AboutYouValidation";
import { allFieldsValidation as educationEmploymentValidation } from "../validation/quickQuote/EducationEmploymentValidation";
import { allFieldsValidation as yourHomeValidation } from "../validation/quickQuote/YourHomeValidation";
import { allFieldsValidation as yourLicenseValidation } from "../validation/quickQuote/YourLicenseValidation";
import { allFieldsValidation as drivingHistoryValidation } from "../validation/quickQuote/DrivingHistoryValidation";
import { allFieldsValidation as currentInsuranceValidation } from "../validation/quickQuote/CurrentInsuranceValidation";
import { allFieldsValidation as insuranceHistoryValidation } from "../validation/quickQuote/InsuranceHistoryValidation";
import { allFieldsValidation as yourNewPolicyValidation } from "../validation/quickQuote/YourNewPolicyValidation";
import { allFieldsValidation as contactInfoValidation } from "../validation/quickQuote/ContactInfoValidation";
import USPSClient from "../classes/USPSClient";


const quoteApiClient = new QuoteApiClient();
const vehiclesApiClient = new VehiclesApiClient();
const driversApiClient = new DriversApiClient();
const insuranceApiClient = new InsuranceApiClient();

//export const startQuote = (zipCode: string) => (dispatch) => {

//    const { isValid, errors } = startQuoteValidation({ zipCode });

//    if (!isValid) {
//        validationUtils.publishValidationFailure(errors);
//        return Promise.reject();
//    }

//    var promise = Promise.resolve(zipCode);

//    promise.then((response) => {
//        dispatch({
//            type: ACTIONS.QUOTE_STARTED,
//            zipCode: response
//        });
//    });

//    return promise;
//};

export const startQuote = (zipCode: string) => (dispatch) => {

    return startQuoteValidation({ zipCode }).then(
        () => {      

            //var promise = Promise.resolve(zipCode);
            var promise = USPSClient.getAreaByZip(zipCode)
                .then((result: any) => {

                dispatch({
                    type: ACTIONS.QUOTE_STARTED,
                    zipCode: result.zip,
                    stateCode: result.state
                });

                return quoteApiClient.createQuote(zipCode);
            })
            //.then(() => { console.log("create quote"); return quoteApiClient.createQuote(zipCode); })
            .then((response) => {
                dispatch({
                    type: ACTIONS.QUOTE_CREATED,
                    quote: { uid: response.data.uid, quoteId: response.data.quoteId }
                });

                return { quoteUid: response.data.uid, quoteId: response.data.quoteId }
            });

            return promise;
        },
        (errors) => {
            validationUtils.publishValidationFailure(errors);
            return Promise.reject();
        }
    );
};

export const changeZip = (zipCode: string) => (dispatch) => {

    return startQuoteValidation({ zipCode }).then(
        () => {

            var promise = USPSClient.getAreaByZip(zipCode);

            promise.then((result: any) => {

                dispatch({
                    type: ACTIONS.CHANGE_ZIP,
                    zipCode: result.zip,
                    stateCode: result.state,
                    city: result.city
                });
            });

            return promise;
        },
        (errors) => {
            validationUtils.publishValidationFailure(errors);
            return Promise.reject();
        }
    );
};

export const quoteStepChanged = (currentStep: string) => (dispatch) => {
    dispatch({
        type: ACTIONS.QUOTE_STEP_CHANGED,
        currentStep: currentStep
    });

    //eventEmitter.publish(EVENTS.QUOTE_STEP_CHANGED, currentStep);
};

export const createQuote = (zipCode : string, vehicle: IVehicle | null) => (dispatch, getState) => {

    var promise = quoteApiClient.createQuote(zipCode, vehicle);

    promise.then((response) => {
        if (vehicle && response.data && response.data.hasOwnProperty) {
            vehicle.id = response.data.vehicleId;
        }

        dispatch({
            type: ACTIONS.QUOTE_CREATED,
            quote: { uid: response.data.uid, vehicle: vehicle },
        });
    });
    
    return promise;
};

export const loadQuote = (quote: any) => (dispatch) => {

    dispatch({
        type: ACTIONS.LOAD_QUOTE,
        quote: quote
    });

    return Promise.resolve();
};

//export const updateVehicles = (vehicle : IVehicle) => (dispatch, getState) => {
//    console.log("updateVehicles");
    
//    dispatch({
//        type: ACTIONS.UPDATE_VEHICLES,
//        vehicle: vehicle,
//    });

//    var promise = vehiclesApiClient.updateVehicles(vehicle);

//    return promise;
//};

export const updateVehicle = (quoteUid: string, vehicle: IVehicle, quoteStep : string) => (dispatch, getState) => {

    let validator: ((data: any) => any) | null;

    switch (quoteStep) {
        case QUOTE_STEPS.VEHICLE_DETAILS:
            validator = vehicleDetailsValidation;
            break;
        case QUOTE_STEPS.HOW_YOU_DRIVE:
            validator = howYouDriveValidation;
            break;
        default:
            validator = null;
    }

    if (null !== validator) {
        const { isValid, errors } = validator(vehicle);
        if (!isValid) {
            validationUtils.publishValidationFailure(errors);
            return Promise.reject();
        }
    }

    var promise = vehiclesApiClient.updateVehicle(quoteUid, vehicle, quoteStep);

    promise.then((response) => {
        vehicle.id = response.data.vehicleId;

        dispatch({
            type: ACTIONS.UPDATE_VEHICLE,
            vehicle: vehicle,
        });
    });

    return promise;
};

export const updateDriver = (quoteUid: string, driver: IDriver, quoteStep: string) => (dispatch, getState) => {
    let validator: ((data: any) => any) | null;

    switch (quoteStep) {
        case QUOTE_STEPS.ABOUT_YOU:
            validator = aboutYouValidation;
            break;
        case QUOTE_STEPS.EDUCATION_EMPLOYMENT:
            validator = educationEmploymentValidation;
            break;
        case QUOTE_STEPS.YOUR_HOME:
            validator = yourHomeValidation;
            break;
        case QUOTE_STEPS.YOUR_LICENSE:
            validator = yourLicenseValidation;
            break;
        case QUOTE_STEPS.DRIVING_HISTORY:
            validator = drivingHistoryValidation;
            break;
        default:
            validator = null;
    }

    console.log("validation.isInsured = " + driver.isInsured);
    if (null !== validator) {
        const { isValid, errors } = validator(driver);
        if (!isValid) {
            validationUtils.publishValidationFailure(errors);
            return Promise.reject();
        }
    }

    var promise = driversApiClient.updateDriver(quoteUid, driver, quoteStep);

    promise.then((response) => {
        driver.id = response.data.driverId;

        dispatch({
            type: ACTIONS.UPDATE_DRIVER,
            driver: driver,
        });
    });

    return promise;
};

export const updateInsurance = (quoteUid: string, currentInsurance: ICurrentInsurance, quoteStep: string) => (dispatch, getState) => {
    
    let validator: ((data: any) => any) | null;

    switch (quoteStep) {
        case QUOTE_STEPS.CURRENT_INSURANCE:
            validator = currentInsuranceValidation;
            break;
        case QUOTE_STEPS.INSURANCE_HISTORY:
            validator = insuranceHistoryValidation;
            break;
        case QUOTE_STEPS.NEW_POLICY:
            console.log("yourNewPolicyValidation");
            validator = yourNewPolicyValidation;
            break;
        default:
            validator = null;
    }

    console.log(currentInsurance);
    if (null !== validator) {
        const { isValid, errors } = validator(currentInsurance);
        if (!isValid) {
            validationUtils.publishValidationFailure(errors);
            return Promise.reject();
        }
    }

    var promise = insuranceApiClient.updateInsurance(quoteUid, currentInsurance, quoteStep);

    promise.then((response) => {
        currentInsurance.id = response.data.insuranceId;

        dispatch({
            type: ACTIONS.UPDATE_INSURANCE,
            currentInsurance: currentInsurance,
        });
    });

    return promise;
};

export const updateContactInfo = (quoteUid: string, contactInfo: IContactInfo, quoteStep: string) => (dispatch, getState) => {

    const { isValid, errors } = contactInfoValidation(contactInfo);

    if (!isValid) {
        validationUtils.publishValidationFailure(errors);
        return Promise.reject();
    }

    var promise = quoteApiClient.updateContactInfo(quoteUid, contactInfo, quoteStep);

    promise.then((response) => {
        contactInfo.id = response.data.contactInfoId;

        dispatch({
            type: ACTIONS.UPDATE_CONTACT_INFO,
            contactInfo: contactInfo,
        });
    });

    return promise;
};

export const selectCoverageConfig = (coverageConfig: ICoverageConfig) => (dispatch) => {
    dispatch({
        type: ACTIONS.SELECT_COVERAGE_CONFIG,
        coverageConfig: coverageConfig,
    });

    return Promise.resolve();
};

export const selectPaymentChoice = (quoteUid: string, rate: IRealTimeAutoResult | null, paymentChoice: IPaymentChoice | null, agenciesContactInfo: IAgenciesContactInfo | null) => (dispatch, getState) => {
    if (null != paymentChoice
        && null != agenciesContactInfo
        && null != agenciesContactInfo.agencyContacts
        && agenciesContactInfo.agencyContacts.length > 0
        && null != agenciesContactInfo.agencyContacts[0].producerCode
        && null != agenciesContactInfo.agencyContacts[0].storeNumber) {

        const promise = quoteApiClient.updateQuoteAgency(quoteUid, agenciesContactInfo.agencyContacts[0].producerCode,
            agenciesContactInfo.agencyContacts[0].storeNumber);

        promise.then(() => {
            dispatch({
                type: ACTIONS.PAYMENT_CHOICE_SELECTED,
                rate: rate,
                paymentChoice: paymentChoice,
                agenciesContactInfo: agenciesContactInfo
            });
        });

        return promise;
    }
    else {
        dispatch({
            type: ACTIONS.PAYMENT_CHOICE_SELECTED,
            rate: rate,
            paymentChoice: paymentChoice,
            agenciesContactInfo: agenciesContactInfo
        });
    }

    return Promise.resolve();
};

export const selectRtrPaymentChoice = (rate: IRealTimeAutoResult, paymentChoice: IPaymentChoice) => (dispatch, getState) => {
    dispatch({
        type: ACTIONS.RTR_PAYMENT_CHOICE_SELECTED,
        rate: rate,
        paymentChoice: paymentChoice,
    });

    return Promise.resolve();
};

export const agentLandingQuote = (quoteUid: string) => (dispatch) => {

    let _quoteUid;
    let _quoteId;

    return quoteApiClient.getQuote(quoteUid)
        .then((quoteData) => {
            dispatch({
                type: ACTIONS.LOAD_QUOTE,
                quote: quoteData.data
            });

            _quoteUid = quoteData.data.uid;
            _quoteId = quoteData.data.Id;

            return quoteApiClient.getContactInfo(quoteUid);
        }, (errors) => {
            validationUtils.publishValidationFailure(errors);
            return Promise.reject();
        })
        .then((cinfoData) => {
            dispatch({
                type: ACTIONS.LOAD_CONTACT_INFO,
                contactInfo: cinfoData.data
            });

            return { quoteUid: _quoteUid, quoteId: _quoteId }
        }, (errors) => {
            validationUtils.publishValidationFailure(errors);
            return Promise.reject();
        });
};


